import styled from 'styled-components';

export const SkipTraceContainer = styled.div`
  margin: auto;
  width: max-content;
  margin-top: 8px;
  z-index: 9;
`;
